var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNavigator(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 253,
    height: 140,
    viewBox: "0 0 253 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "undraw_navigator_a479 1",
    clipPath: "url(#clip0_549_336491)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M66.1786 43.8566C74.1622 43.8566 80.6341 37.3846 80.6341 29.4011C80.6341 21.4175 74.1622 14.9456 66.1786 14.9456C58.1951 14.9456 51.7231 21.4175 51.7231 29.4011C51.7231 37.3846 58.1951 43.8566 66.1786 43.8566Z",
    fill: "#FF6584"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M111.509 73.9476H40.5951C40.5063 73.9488 40.4176 73.9418 40.3301 73.9266L73.8693 15.8319C74.074 15.4701 74.3711 15.1691 74.7301 14.9597C75.0892 14.7502 75.4975 14.6399 75.9132 14.6399C76.3289 14.6399 76.7371 14.7502 77.0962 14.9597C77.4553 15.1691 77.7524 15.4701 77.9571 15.8319L100.466 54.818L101.544 56.6835L111.509 73.9476Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    opacity: 0.2,
    d: "M111.509 73.9476H87.2974L99.1829 56.6833L100.038 55.4398L100.466 54.8181L101.545 56.6833L111.509 73.9476Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M150.994 73.9476H89.6589L101.544 56.6834L102.4 55.4398L117.888 32.9412C118.903 31.4667 121.346 31.3749 122.54 32.6631C122.62 32.751 122.694 32.8439 122.763 32.9412L150.994 73.9476Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M168.998 64.3903C171.404 64.3903 173.354 62.4401 173.354 60.0344C173.354 57.6287 171.404 55.6785 168.998 55.6785C166.593 55.6785 164.642 57.6287 164.642 60.0344C164.642 62.4401 166.593 64.3903 168.998 64.3903Z",
    fill: "#425CC7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M169.418 73.1547H168.526L168.933 59.3783L169.418 73.1547Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M169.011 61.9894L169.969 60.6641L168.998 62.3174L168.894 62.1337L169.011 61.9894Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M168.907 63.3275L167.949 62.0024L168.92 63.6555L169.025 63.4718L168.907 63.3275Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M208.956 64.3903C211.361 64.3903 213.312 62.4401 213.312 60.0344C213.312 57.6287 211.361 55.6785 208.956 55.6785C206.55 55.6785 204.6 57.6287 204.6 60.0344C204.6 62.4401 206.55 64.3903 208.956 64.3903Z",
    fill: "#425CC7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M209.376 73.1547H208.483L208.89 59.3783L209.376 73.1547Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M208.969 61.9894L209.927 60.6641L208.956 62.3174L208.851 62.1337L208.969 61.9894Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M208.864 63.3275L207.906 62.0024L208.877 63.6555L208.982 63.4718L208.864 63.3275Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M181.617 60.2104C185.17 60.2104 188.05 57.3301 188.05 53.7771C188.05 50.2241 185.17 47.3438 181.617 47.3438C178.064 47.3438 175.183 50.2241 175.183 53.7771C175.183 57.3301 178.064 60.2104 181.617 60.2104Z",
    fill: "#425CC7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M182.237 73.1548H180.919L181.52 52.8082L182.237 73.1548Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M181.636 56.6642L183.051 54.7073L181.617 57.1489L181.462 56.8775L181.636 56.6642Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M181.481 58.6408L180.067 56.6838L181.5 59.1251L181.656 58.854L181.481 58.6408Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M197.306 60.2104C200.859 60.2104 203.739 57.3301 203.739 53.7771C203.739 50.2241 200.859 47.3438 197.306 47.3438C193.753 47.3438 190.872 50.2241 190.872 53.7771C190.872 57.3301 193.753 60.2104 197.306 60.2104Z",
    fill: "#425CC7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M197.926 73.1548H196.608L197.209 52.8082L197.926 73.1548Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M197.325 56.6642L198.74 54.7073L197.306 57.1489L197.151 56.8775L197.325 56.6642Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M197.17 58.6408L195.755 56.6838L197.189 59.1251L197.344 58.854L197.17 58.6408Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M156.613 60.2104C160.166 60.2104 163.046 57.3301 163.046 53.7771C163.046 50.2241 160.166 47.3438 156.613 47.3438C153.059 47.3438 150.179 50.2241 150.179 53.7771C150.179 57.3301 153.059 60.2104 156.613 60.2104Z",
    fill: "#425CC7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M157.233 73.1548H155.915L156.516 52.8082L157.233 73.1548Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M156.632 56.6642L158.046 54.7073L156.613 57.1489L156.458 56.8775L156.632 56.6642Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M156.477 58.6408L155.062 56.6838L156.497 59.1251L156.651 58.854L156.477 58.6408Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M232.725 140H22.7767C20.1315 140 17.5123 139.479 15.0684 138.467C12.6246 137.454 10.4041 135.971 8.53368 134.1C6.66326 132.23 5.17957 130.009 4.1673 127.566C3.15504 125.122 2.63403 122.502 2.63403 119.857C2.63403 117.212 3.15504 114.593 4.1673 112.149C5.17957 109.705 6.66326 107.485 8.53368 105.614C10.4041 103.744 12.6246 102.26 15.0684 101.248C17.5123 100.236 20.1315 99.7147 22.7767 99.7147H232.26C234.315 99.7147 236.286 98.8984 237.738 97.4456C239.191 95.9927 240.008 94.0222 240.008 91.9675C240.008 89.9128 239.191 87.9423 237.738 86.4894C236.286 85.0365 234.315 84.2203 232.26 84.2203H15.8042V71.8248H232.26C237.603 71.8248 242.726 73.947 246.503 77.7245C250.281 81.502 252.403 86.6253 252.403 91.9675C252.403 97.3097 250.281 102.433 246.503 106.211C242.726 109.988 237.603 112.11 232.26 112.11H22.7767C20.722 112.11 18.7515 112.926 17.2986 114.379C15.8457 115.832 15.0295 117.803 15.0295 119.857C15.0295 121.912 15.8457 123.883 17.2986 125.335C18.7515 126.788 20.722 127.605 22.7767 127.605H232.725V140Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M33.158 77.7126H23.5515V78.3324H33.158V77.7126Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M60.428 77.7126H50.8215V78.3324H60.428V77.7126Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M87.6981 77.7126H78.0916V78.3324H87.6981V77.7126Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M114.968 77.7126H105.362V78.3324H114.968V77.7126Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M142.238 77.7126H132.632V78.3324H142.238V77.7126Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M169.508 77.7126H159.902V78.3324H169.508V77.7126Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M196.778 77.7126H187.172V78.3324H196.778V77.7126Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M224.048 77.7126H214.442V78.3324H224.048V77.7126Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M33.158 105.603H23.5515V106.222H33.158V105.603Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M60.428 105.603H50.8215V106.222H60.428V105.603Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M87.6981 105.603H78.0916V106.222H87.6981V105.603Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M114.968 105.603H105.362V106.222H114.968V105.603Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M142.238 105.603H132.632V106.222H142.238V105.603Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M169.508 105.603H159.902V106.222H169.508V105.603Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M196.778 105.603H187.172V106.222H196.778V105.603Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M224.048 105.603H214.442V106.222H224.048V105.603Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M33.158 133.492H23.5515V134.112H33.158V133.492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M60.428 133.492H50.8215V134.112H60.428V133.492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M87.6981 133.492H78.0916V134.112H87.6981V133.492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M114.968 133.492H105.362V134.112H114.968V133.492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M142.238 133.492H132.632V134.112H142.238V133.492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M169.508 133.492H159.902V134.112H169.508V133.492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    d: "M196.778 133.492H187.172V134.112H196.778V133.492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    d: "M224.048 133.492H214.442V134.112H224.048V133.492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    d: "M168.544 24.5964C169.553 24.5955 170.546 24.852 171.429 25.3418H165.667C166.547 24.8522 167.537 24.5956 168.544 24.5964Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_51",
    d: "M157.364 23.8511C159.05 23.8491 160.695 24.3699 162.072 25.3418H152.662C154.038 24.3711 155.68 23.8503 157.364 23.8511Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_52",
    d: "M94.0332 14.4157C94.2376 10.8004 95.7194 7.37521 98.2144 4.75081C100.709 2.12641 104.055 0.473404 107.656 0.086514C111.256 -0.300376 114.877 0.603994 117.872 2.63839C120.868 4.67278 123.044 7.70496 124.012 11.1943C124.197 11.1877 124.382 11.1802 124.569 11.1802C127.87 11.1808 131.082 12.2502 133.724 14.2285C136.367 16.2067 138.298 18.9875 139.229 22.1546C141.416 21.1935 143.861 20.985 146.179 21.5617C148.498 22.1385 150.56 23.4679 152.042 25.3418H104.38C102.99 25.3457 101.613 25.0691 100.332 24.5283C99.0507 23.9876 97.892 23.1939 96.9249 22.1948C95.9579 21.1958 95.2024 20.0118 94.7036 18.7139C94.2049 17.4159 93.9731 16.0307 94.0223 14.6411C94.0254 14.5661 94.029 14.491 94.0332 14.4157Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    d: "M172.022 35.7524C171.013 35.7515 170.02 36.008 169.137 36.4978H174.899C174.019 36.0082 173.029 35.7516 172.022 35.7524Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_54",
    d: "M183.202 35.0071C181.516 35.0051 179.871 35.5259 178.494 36.4978H187.904C186.528 35.5271 184.886 35.0063 183.202 35.0071Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_55",
    d: "M246.533 25.5716C246.328 21.9563 244.846 18.5311 242.351 15.9067C239.856 13.2823 236.51 11.6293 232.91 11.2424C229.31 10.8555 225.689 11.7599 222.693 13.7943C219.698 15.8287 217.522 18.8608 216.554 22.3502C216.369 22.3435 216.184 22.3361 215.997 22.3361C212.696 22.3367 209.484 23.4061 206.841 25.3844C204.199 27.3626 202.268 30.1433 201.337 33.3105C199.149 32.3494 196.705 32.1409 194.386 32.7176C192.068 33.2943 190.006 34.6238 188.524 36.4977H236.186C237.576 36.5016 238.953 36.2249 240.234 35.6842C241.515 35.1435 242.674 34.3498 243.641 33.3507C244.608 32.3516 245.363 31.1677 245.862 29.8697C246.361 28.5718 246.593 27.1866 246.543 25.797C246.54 25.722 246.537 25.6469 246.533 25.5716Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_56",
    d: "M214.757 131.338L220.296 131.341L220.297 130.461L214.757 130.458L214.757 131.338Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_57",
    d: "M174.706 130.657L175.849 130.921L219.286 130.945L219.676 130.035C220.357 128.474 220.591 126.754 220.351 125.068C220.164 123.811 219.696 122.562 218.631 122.02L216.703 109.181L192.672 109.138L183.375 116.637C183.375 116.637 178.989 116.558 176.606 119.525C175.747 120.628 175.239 121.964 175.15 123.359L175.056 124.902L174.706 130.657Z",
    fill: "#425CC7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_58",
    d: "M184.246 135.806C187.209 135.806 189.61 133.404 189.61 130.442C189.61 127.48 187.209 125.079 184.246 125.079C181.284 125.079 178.883 127.48 178.883 130.442C178.883 133.404 181.284 135.806 184.246 135.806Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_59",
    d: "M184.247 133.265C185.806 133.265 187.069 132.001 187.069 130.442C187.069 128.883 185.806 127.619 184.247 127.619C182.687 127.619 181.424 128.883 181.424 130.442C181.424 132.001 182.687 133.265 184.247 133.265Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_60",
    d: "M210.713 135.82C213.675 135.82 216.076 133.419 216.076 130.456C216.076 127.494 213.675 125.093 210.713 125.093C207.75 125.093 205.349 127.494 205.349 130.456C205.349 133.419 207.75 135.82 210.713 135.82Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_61",
    d: "M210.713 133.279C212.272 133.279 213.536 132.015 213.536 130.456C213.536 128.897 212.272 127.633 210.713 127.633C209.154 127.633 207.89 128.897 207.89 130.456C207.89 132.015 209.154 133.279 210.713 133.279Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_62",
    d: "M187.069 115.761L200.043 115.766H201.627L204.301 115.768V115.573L204.303 113.221L204.305 110.581H202.526L200.942 110.579L198.137 110.577H196.553L193.314 110.575L187.069 115.761Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_63",
    d: "M206.413 115.77L213.27 115.774L213.271 114.428V112.077L213.273 110.587H212.269L210.686 110.585L206.415 110.583L206.413 115.77Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_64",
    d: "M203.42 121.308L204.299 121.308L204.3 119.638L203.42 119.637L203.42 121.308Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_65",
    d: "M190.584 118.136L190.584 117.256L188.914 117.255L188.913 118.135L190.584 118.136Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_66",
    d: "M189.969 117.643L189.872 117.643C189.631 117.643 189.392 117.595 189.169 117.503C188.946 117.41 188.743 117.275 188.573 117.104C188.402 116.933 188.267 116.731 188.175 116.508C188.083 116.285 188.035 116.046 188.035 115.804C188.035 115.563 188.083 115.324 188.176 115.101C188.268 114.878 188.404 114.676 188.574 114.505C188.745 114.335 188.948 114.199 189.171 114.107C189.394 114.015 189.633 113.967 189.874 113.968L189.971 113.968L189.969 117.643Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_67",
    d: "M175.056 124.902C175.721 124.975 176.39 124.81 176.945 124.437C177.501 124.065 177.907 123.508 178.092 122.865C178.277 122.223 178.23 121.535 177.958 120.924C177.686 120.313 177.207 119.817 176.606 119.525C175.747 120.627 175.239 121.964 175.15 123.359L175.056 124.902Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_68",
    d: "M200.942 110.579L204.301 115.573L204.303 113.221L202.526 110.581L200.942 110.579Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_69",
    d: "M210.686 110.585L213.272 114.428V112.077L212.269 110.587L210.686 110.585Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_70",
    d: "M196.553 110.577L200.043 115.766H201.627L198.137 110.577H196.553Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_71",
    d: "M14.2548 88.5588C22.1275 88.5588 28.5096 82.1767 28.5096 74.304C28.5096 66.4313 22.1275 60.0492 14.2548 60.0492C6.38209 60.0492 0 66.4313 0 74.304C0 82.1767 6.38209 88.5588 14.2548 88.5588Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_72",
    d: "M14.3141 78.5955L7.18047 71.4619C6.94842 71.2293 6.81818 70.9142 6.81836 70.5856C6.81854 70.2571 6.94913 69.9421 7.18143 69.7098C7.41374 69.4775 7.72877 69.3469 8.0573 69.3467C8.38584 69.3465 8.701 69.4768 8.93357 69.7088L14.1954 74.9707L30.9864 55.8232C31.2033 55.5766 31.5092 55.4261 31.8369 55.4048C32.1647 55.3836 32.4875 55.4932 32.7344 55.7098C32.9814 55.9263 33.1323 56.2321 33.154 56.5598C33.1757 56.8875 33.0665 57.2104 32.8503 57.4577L14.3141 78.5955Z",
    fill: "#425CC7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_549_336491"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 252.403,
    height: 140,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigator);
export default __webpack_public_path__ + "static/media/navigator.afc647c39ed1a09ca94a6e9c2462e404.svg";
export { ForwardRef as ReactComponent };